<!-- =========================================================================================
  File Name: ProductionStart.vue
  Description: Add ProductionStart
  ----------------------------------------------------------------------------------------
  Item Name: Vaagai Tecknowledge - Easy Admin
  Author: Web Team
  Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6" id="production-start">
        <form @submit.prevent="submitForm">

            <h5 class="text-primary">Production Details</h5>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Finished Products Date </span>
                    <datepicker placeholder="Finished Products Date" v-model="FinishedProductsDate" :format="dateFormat" :disabledDates="disabledDates" ></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('FinishedProductsDate')">{{ errors.first('FinishedProductsDate') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Start Time </span>
                    <!-- <vs-input class="w-full" label-placeholder="Start Time" v-model="StartTime" v-validate="'required'" name="StartTime" /> -->
                    <datetime type="datetime" v-model="StartTime" use12-hour :max-datetime="maxDatetime" format="dd-MMM-yyyy hh:mm a" ></datetime>
                    <span class="text-danger text-sm" v-show="errors.has('StartTime')">{{ errors.first('StartTime') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Reference Number" v-model="ReferenceNumber" v-validate="'required'" name="ReferenceNumber" />
                    <span class="text-danger text-sm" v-show="errors.has('ReferenceNumber')">{{ errors.first('ReferenceNumber') }}</span>
                </div>
            </div>

            <div class="vx-row">

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Prepared By Id </span>
                    <v-select v-model="PreparedById" name="PreparedById" :value="PreparedById" :options="PreparedByIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('PreparedById')">{{ errors.first('PreparedById') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Supervisor Id </span>
                    <v-select v-model="SupervisorId" name="SupervisorId" :value="SupervisorId" :options="SupervisorIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('SupervisorId')">{{ errors.first('SupervisorId') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Select Product </span>
                    <v-select v-model="ProductId" name="ProductId" :value="ProductId" :options="ProductIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('ProductId')">{{ errors.first('ProductId') }}</span>
                </div>
            </div>

            <h5 class="text-primary">Primary Raw Material Details</h5>

            <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Primary Raw Material </span>
                    <h3> {{ PrimaryProductName }} </h3>
                    <span class="text-danger text-sm" v-show="errors.has('PrimaryProductId')">{{ errors.first('PrimaryProductId') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Current Stock </span>
                    <h3> {{ PrimaryCurrentStock }} </h3>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Required Qty </span>
                    <h3> {{ PrimaryRequiredQty }} </h3>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Taken Qty" v-model="PrimaryProductQty" v-validate="'required'" name="PrimaryProductQty" />
                    <span class="text-danger text-sm" v-show="errors.has('PrimaryProductQty')">{{ errors.first('PrimaryProductQty') }}</span>
                </div>
            </div>

            <h5 class="text-primary">Secondary Raw Material Details</h5>

            <!-- <div class="vx-row"> -->
                <vs-table :data="Products">

                    <template slot="thead">
                        <vs-th> Product Name and Code</vs-th>
                        <vs-th> Current Stock</vs-th>
                        <vs-th> Required Qty </vs-th>
                        <vs-th> Taken Qty </vs-th>
                    </template>

                    <vs-tr v-for="(Product, k) in Products" :key="k">

                        <vs-td>
                            {{ Product.ProductName }} {{ Product.ProductDescription }} {{ Product.CustomCode }} 
                        </vs-td>

                        <vs-td>
                            {{ Product.CurrentStock }} {{ Product.UnitSymbol }}
                        </vs-td>

                        <vs-td>
                            {{ Product.RequiredQty }} {{ Product.UnitSymbol }}
                        </vs-td>
                        
                        <vs-td>
                            <vs-input class="box-size" style="--size: 200px;" placeholder="Taken Qty" v-model="Product.RawMaterialQty" v-validate="'required|decimal:3|min_value:0.001'" name="ProductQty" icon-pack="fa" icon="fa-cubes" />
                            <span class="text-danger text-sm" v-show="errors.has('ProductQty')">{{ errors.first('ProductQty') }}</span>
                        </vs-td>
                    </vs-tr>

                </vs-table>
            <!-- </div> -->


            <div class="vx-row">
                <div class="vx-col w-full text-right mb-3">
                    <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                    <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                </div>
            </div>

        </form>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json';
import { Validator } from 'vee-validate';
import common from '@/views/Common.vue';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import { Datetime } from 'vue-datetime';
import { DateTime as LuxonDateTime } from 'luxon';

const dict = {
  custom: {      
    FinishedProductsDate: { required : 'Finished Products Date should not be empty', },
    StartTime: { required : 'Start Time should not be empty', },
    ReferenceNumber: { required : 'Reference Number should not be empty', },
    PreparedById: { required : 'Prepared By should not be empty', },
    SupervisorId: { required : 'Supervisor Id should not be empty', },
    ProductId: { required : 'Product Id should not be empty', },
  }
};

Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
        Datepicker,
        datetime: Datetime
    },
    props: {
        addRecordPrompt: {
            type: Boolean,
            required: true,
        },
    },    
    data() {
        return {
            // activePrompt: false,

            ProductIdOptions : [],
            PreparedByIdOptions: [],
            SupervisorIdOptions: [],

            dateFormat: "d-MMM-yyyy",
            disabledDates: {
                from: new Date(),
            },
            CurrentTime: LuxonDateTime.local().plus({ days: 0 }).toISO(),
            maxDatetime: LuxonDateTime.local().plus({ days: 1 }).toISO(),

            FinishedProductsDate : new Date(),
            StartTime : LuxonDateTime.local().plus({ days: 0 }).toISO(),
            ReferenceNumber : '',
            PreparedById : '',
            SupervisorId : '',
            ProductId : '',
            PrimaryProductId : '',
            PrimaryProductName : '',
            PrimaryCurrentStock : '',
            PrimaryRequiredQty : '',
            PrimaryProductQty : '',

            Products: [],

        }
    },
    computed: {
        dataArrayLength() {
            return this.$store.getters['productionList/dataArrayLength'];
        },
        allProducts(){
            return this.$store.getters['product/dataList'];
        },
        allProductionRules(){
            return this.$store.getters['productionRules/dataList'];
        },
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideProductionStartPrompt');
        },
        addRecordDetails() {
            // add todo in store and clear all fields in dialog

            var date1=this.FinishedProductsDate;
            var date2=this.StartTime;

            if (date1 != "" && date2 != "") {
                var recordObj={
                    "FinishedProductsDate" :  date1, 
                    "StartTime" :  date2, 
                    "ReferenceNumber" :  this.ReferenceNumber, 
                    "PreparedById" :  this.PreparedById, 
                    "SupervisorId" :  this.SupervisorId, 
                    "ProductId" :  this.ProductId, 
                    "PrimaryProductId" :  this.PrimaryProductId, 
                    "PrimaryProductQty" :  this.PrimaryProductQty, 
                    "Products" :  this.Products, 
                };

                var server_url=companyConfig.apiURL;
                var record={};
                record.token=this.$session.get('token');
                record.add_url=server_url+'lib/api/production/production/start';
                record.form=recordObj;
                record.list_url=server_url+'lib/api/production/production/lists';
                record.list_where={
                    "where": {
                        "finished_products_id >=": 1
                    },
                    "or_where": {}
                };
                console.log('record='+JSON.stringify(record));
                record.loading=this.$vs.loading;
                record.notify=this.$vs.notify;
                record.http=this.$http;            
                this.$store.dispatch('productionList/addRecordDetails', record);

                this.closePrompt();

            } else {
                var message='Date and Start Time should not be empty';
                this.errorMessage(message);
            }
        },
        clearFields() {
            // clear all fileds in todo
            this.FinishedProductsDate =  new Date();
            this.StartTime = this.CurrentTime;
            this.ReferenceNumber = '';
            this.PreparedById = '';
            this.SupervisorId = '';
            this.ProductId =  '';
            this.ProductCurrentStock =  '';
            this.Prod
            this.ExpectedQty =  '';
            this.PrimaryProductId =  '';
            this.PrimaryProductName =  '';
            this.PrimaryCurrentStock =  '';
            this.PrimaryRequiredQty =  '';
            this.PrimaryProductQty =  '';
            this.Products =  [];

            this.$parent.addRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.addRecordDetails();
            })
        },
        addNewRow() {
            this.Products.push({
                RawMaterialId: '',
                ProductStock: '',
                RawMaterialQty: '',
            });
        },
        deleteRow(index, Product) {
            console.log('deleteRow called');
            console.log('index='+index+', Product='+JSON.stringify(Product));
            if (index > -1) {
                this.Products.splice(index, 1);
            }
        },
        checkProduct(temp_code){
            console.log('temp_code='+temp_code);
            console.log('allProducts='+JSON.stringify(this.allProducts));
            // ProductCustomCode or ProductVariantId or VariantProductName
            var idx = this.allProducts.map(e => e.ProductVariantId).indexOf(temp_code);
            return idx;
        },
        checkCustomCode(index, Product) {
            console.log('checkCustomCode called');
            console.log('index='+index+', Product='+JSON.stringify(Product));
            var temp_code=Product.ProductId;
            console.log('temp_code='+temp_code);
            var idx = this.checkProduct(temp_code);
            console.log('idx='+idx);
            if (idx >= 0) {
                // idx = 0;
                // this.PartyDetails = this.allProducts[idx];

                var ProductStock = this.allProducts[idx]['ProductStock'];

                // this.Products[index].ProductId = ProductVariantId;
                this.Products[index].ProductStock = ProductStock;
                this.Products[index].ProductQty = '';
                
            }else{
                var message='Product custom code is invalid';
                this.errorMessage(message);
                this.Products[index].ProductStock = '';
                this.Products[index].ProductQty = '';
            }
            
        },
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            var server_url=companyConfig.apiURL;

            // Load Products

            var getAllRecords={};
            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/product/product/lists';
            getAllRecords.list_where={};
            console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;    
            this.$store.dispatch('product/loadAllRecords', getAllRecords);

            // Load Production Rules

            getAllRecords={};
            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/production/rules/lists';
            getAllRecords.list_where={
                "where": {
                    "production_rules_product_company_relation_id >=": 1
                },
                "or_where": {}
            };
            console.log('server_url='+server_url+', beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;
            this.$store.dispatch('productionRules/loadAllRecords', getAllRecords);

            // Load Product Id Dropdown
            
            var selectbox1_source = 'ProductId'
            var selectbox1_destination = 'ProductIdOptions'
            var selectbox1_url = 'lib/api/data/get_production_products_options'
            var selectbox1_conditions_array = {
                'where': {
                    'production_rules_id >=': 1
                },
                'or_where': {}
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);

            // Load Prepared By Dropdown

            var selectbox2_source = 'PreparedById'
            var selectbox2_destination = 'PreparedByIdOptions'
            var selectbox2_url = 'lib/api/data/get_supplier_options'
            var selectbox2_conditions_array = {
                'PartyCategoryId':3,
                'where': {
                    'party_details_party_category_id': 3
                }
            }
            this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url);

            // Load Supervisor Dropdown

            var selectbox3_source = 'SupervisorId'
            var selectbox3_destination = 'SupervisorIdOptions'
            var selectbox3_url = 'lib/api/data/get_supplier_options'
            var selectbox3_conditions_array = {
                'PartyCategoryId':3,
                'where': {
                    'party_details_party_category_id': 3
                }
            }
            this.getSelectBoxOptions(selectbox3_source, selectbox3_destination, selectbox3_conditions_array, selectbox3_url);

        }
    },
    watch: {
        ProductIdOptions: function(){
            console.log('watch ProductIdOptions='+JSON.stringify(this.ProductIdOptions));
            var n1=this.ProductIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.ProductIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.ProductId;                
                var str2=str1.toString();
                var index1 = this.ProductIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index1='+index1);
                this.ProductId=index1 >= 0 ? str2 : "";
            }
        },
        ProductId: function(){
            console.log('watch ProductId');
            var temp=this.ProductId;
            if (temp != "") {
                var index = this.allProductionRules.map(e => e.ProductId).indexOf(temp);
                console.log('index='+index);
                if (index >= 0) {
                    var primary = this.allProductionRules[index]['PrimaryProducts'];
                    var secondary = this.allProductionRules[index]['SecondaryProducts'];
                    var n1=primary.length;
                    var n2=secondary.length;
                    console.log('n1='+n1+', n2='+n2+', primary='+JSON.stringify(primary)+', secondary='+JSON.stringify(secondary));
                    if (n1 > 0) {
                        var tempProductId = primary[0]['RawMaterialId'];
                        var tempProductName = primary[0]['ProductName'];
                        var tempProductDescription = primary[0]['ProductDescription'];
                        var tempCustomCode = primary[0]['CustomCode'];
                        var tempCurrentStock = primary[0]['CurrentStock'];
                        var tempRequiredQty = primary[0]['RequiredQty'];
                        var tempUnitSymbol = primary[0]['UnitSymbol'];

                        this.PrimaryProductId = tempProductId;
                        this.PrimaryProductName = tempProductName+' '+tempProductDescription+' '+tempCustomCode;
                        this.PrimaryCurrentStock = tempCurrentStock+' '+tempUnitSymbol;
                        this.PrimaryRequiredQty = tempRequiredQty+' '+tempUnitSymbol;
                    }
                    this.Products = n2 > 0 ? secondary : [];
                }
            }
        },
    }
}
</script>
<style lang="scss">
#production-start {
    .vs-con-table .vs-con-tbody {
        z-index: 1;
        width: 100%;
        overflow: visible;
    }
    .vs-con-table {
        overflow: visible;
    }
    .vs-table--content{
        overflow: visible;
    }
}
.con-vs-popup .vs-popup {
    width: 1100px;
}

.box-size{
    width: var(--size);
}
</style>